import AccettazioneFrosinone from "../";

const routes = [

    // { name: "Accettazione Ssn", path: "/accettazionessn/:id", component: AccettazioneSsn.AccettazioneSsnEditViewPage, meta: { title: "Crea/Modifica Accettazione" } },

    { name: "Accettazione Ssn", path: "/frosinone/accettazione/:id", component: AccettazioneFrosinone.AccettazioneSsnEditViewPage, meta: { title: "Crea/Modifica Accettazione" } },
    { name: "Elenco Accettazione", path: "/frosinone/accettazione", component: AccettazioneFrosinone.AccettazioneFrosinoneListPage, meta: { title: "Elenco Accettazioni" } },
    { name: "Prenotazioni Recup", path: "/frosinone/appuntamenti", component: AccettazioneFrosinone.AccettazionePrenotazioniLazioListPage, meta: { title: "Elenco Prenotazione Recup" } },
    { name: "Appuntamenti Recup", path: "/frosinone/accappuntamenti", component: AccettazioneFrosinone.AccettazioneRicettaPrestazioniListaPage, meta: { title: "Elenco Appuntamenti" } },
];

export default routes;
